module.exports = __webpack_public_path__ + "img/Hp-IconBox1-Global-Enablement.f779256c.svg";